import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../../context/LanguageContext';
import { FiStar, FiShield } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

export default function Trust() {
  const { t } = useLanguage();
  const extras = t('trust.extraFeatures');

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-16 items-center">
        
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
        >
          <SafeIcon icon={FiShield} className="text-5xl text-blue-500 mb-6" />
          <h2 className="text-3xl font-bold text-gray-900 mb-4">{t('trust.whyUsTitle')}</h2>
          <p className="text-gray-600 text-lg leading-relaxed mb-8">
            {t('trust.whyUsDesc')}
          </p>
          
          <div className="space-y-3">
            {Array.isArray(extras) && extras.map((item, idx) => (
              <div key={idx} className="flex items-center gap-3 text-gray-800 font-medium bg-gray-50 px-4 py-3 rounded-lg">
                <SafeIcon icon={FiStar} className="text-yellow-400" />
                {item}
              </div>
            ))}
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          className="bg-brand-dark p-10 rounded-3xl text-white shadow-2xl relative overflow-hidden"
        >
          <div className="absolute top-0 right-0 w-64 h-64 bg-blue-500/20 rounded-full blur-3xl translate-x-1/2 -translate-y-1/2"></div>
          
          <h3 className="text-2xl font-bold mb-8 relative z-10">{t('process.title')}</h3>
          <div className="space-y-6 relative z-10">
            {[1, 2, 3, 4].map((step) => (
              <div key={step} className="flex items-start gap-4">
                <div className="w-8 h-8 rounded-full bg-blue-500 flex items-center justify-center font-bold flex-shrink-0">
                  {step}
                </div>
                <div>
                  <h4 className="text-lg font-semibold">{t(`process.s${step}`)}</h4>
                </div>
              </div>
            ))}
          </div>
        </motion.div>

      </div>
    </section>
  );
}